import styled from "@emotion/styled";
import { GlobalSearch } from "src/components/GlobalSearch/GlobalSearch";
import LimitedAccess from "src/components/NewComponents/LimitedAccess";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

function AccessDenied(props: { className?: string }) {
	return (
		<div className={props.className}>
			<GlobalSearch />
			<LimitedAccess />
		</div>
	);
}

export default styled(AccessDenied)`
  padding: 0 5px 15px;

  ${LimitedAccess} {
    margin-bottom: 12px;
    padding: 16px;
    border: 1px solid #f9f4fa;
    border-radius: 28px;

    > div {
      aspect-ratio: 2 / 1;
    }

    ${mq(Breakpoints.sm)} {
      box-shadow: none;
      border: none;
    }
  }
`;
